import "./contextMenu.css";
import type {
	Monitor as MonitorState,
	ScreenerData,
} from "epsm-api-types/models";
import { MonitorStateService } from "@/components/widgets/Monitor/lib/services/MonitorStateService";
import { useGetUserDataFromToken } from "@/hooks/useGetUserDataFromToken";

const noSataItem = {
	label: "No available state",
	key: "noAvailableState",
	hideMenuOnAction: true,
	disabled: true,
	menu: undefined,
};

export const useCellContextMenuItems = () => {
	const userData = useGetUserDataFromToken();
	const userId = userData?.username || "";

	const addTicker = async (selectedState: MonitorState, ticker: string) => {
		const newState = {
			...selectedState,
			tickers: [...(selectedState?.tickers || []), ticker],
		};
		await MonitorStateService.create().addState(
			userId,
			selectedState.itemName,
			newState,
		);
	};

	const getCellContextMenuItems = async ({
		data,
	}: {
		data: Partial<ScreenerData> | null;
	}) => {
		const ticker = data?.ticker ?? "";
		if (!ticker) return [noSataItem];

		const response = await MonitorStateService.create().getStates(userId);
		const lastStates = response.data ?? [];

		const menuItems = lastStates
			.filter((state) => !state?.tickers?.includes(ticker))
			.map((state) => ({
				label: state.itemName,
				key: state.itemName,
				hideMenuOnAction: true,
				onClick: () => addTicker(state, ticker),
			}));

		return [
			{
				label: "Add to Monitor",
				key: "addToMonitor",
				...(!!ticker && {
					menu: {
						items: menuItems.length ? menuItems : [noSataItem],
					},
				}),
			},
		];
	};

	return getCellContextMenuItems;
};
